import { NgModule } from '@angular/core';
import { ModulLibComponent } from './modul-lib.component';



@NgModule({
  declarations: [ModulLibComponent],
  imports: [
  ],
  exports: [ModulLibComponent]
})
export class ModulLibModule { }
